import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const QualityCheckParameterForm = (props) => {
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [parameterName, setParameterName] = useState("");
  const [parameterFor, setParameterFor] = useState("");
  const [observationName, setObservationName] = useState("");
 
  const [itemList, setItemList] = useState([]);

  const fields = ["Field QC", "Arrival QC", "Packhouse QC"];

  const addItemToList = () => {
    if (!parameterFor || !parameterName || !observationName) {
      toast.error(
        "All fields are required: Parameter For, Parameter Name, and Observation Name"
      );
      return;
    }

    const newObservation = { parameterFor, parameterName, observationName };

    if (
      !itemList.some(
        (item) =>
          item.parameterFor === newObservation.parameterFor &&
          item.parameterName === newObservation.parameterName &&
          item.observationName === newObservation.observationName
      )
    ) {
      setItemList((prevItemList) => [...prevItemList, newObservation]);

      setObservationName("");
    } else {
      toast.error("Observation already exists in the list");
    }
  };

  const { sendRequest: postQualityCheckParameter } = useHttp();

  const submitHandler = (data) => {
    const postData = {
      parameterName: parameterName.trim(),
      parameterFor: parameterFor.trim(),
      observationList: itemList,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    };

    //  console.log("Post Data:", postData);

    if (props.update) {
      postData["parameterId"] = props.update.parameterId;
    }

    postQualityCheckParameter(
      {
        url: "/api/qualitycheckparameter/",
        method: props.update ? "PUT" : "POST",
        body: postData,
      },
      (res) => {
        //  console.log("post res data",res)
        toast.success(
          `Quality Check Parameter ${
            props.update ? "Updated" : "Added"
          } Successfully`
        );
        props.addForm(false);
      },
      (error) => {
        toast.error(error || "Something went wrong");
        console.log(error);
      }
    );
  };

  const { sendRequest: getparameter } = useHttp();

  useEffect(() => {
    if (props.update) {
      // console.log(props.update);
      const Id = props.update.parameterId;

      getparameter(
        {
          url: `/api/qualitycheckparameter/?orgId=${localStorage.getItem(
            "orgId"
          )}&parameterId=${Id}`,
        },
        (res) => {
          //   console.log("res:", res);
          setItemList(res.observationList);
        },
        (error) => {
          console.log("Error", error);
        }
      );
      //console.log("updateobservationList", props.update.observationList);
      setParameterFor(props.update.parameterFor);
      setParameterName(props.update.parameterName);
    }
  }, [props.update]);

  const handleDelete = (index, e) => {
    setItemList(itemList.filter((v, i) => i !== index));
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <form style={{ margin: "10px" }} onSubmit={handleSubmit(submitHandler)}>
          <div className="container-fluid">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Quality Check Details</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Parameter For:</label>
                      <select
                        id="fields"
                        value={parameterFor}
                        onChange={(e) => setParameterFor(e.target.value)}
                        className="form-control"
                      >
                        <option value="">Select a Parameter</option>
                        {fields.map((field, index) => (
                          <option key={index} value={field}>
                            {field}
                          </option>
                        ))}
                      </select>
                      {errors.parameterFor && (
                        <span className="text-danger">
                          {errors.parameterFor.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Parameter Name:</label>
                      <input
                        type="text"
                        id="parameterName"
                        className="form-control"
                        value={parameterName}
                        onChange={(e) => setParameterName(e.target.value)}
                      />
                      {errors.parameterName && (
                        <span className="text-danger">
                          {errors.parameterName.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    <h6>Observation Detail:</h6>
                  </label>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Observation Name:</label>
                        <input
                          type="text"
                          id="observationName"
                          className="form-control"
                          value={observationName}
                          onChange={(e) => setObservationName(e.target.value)}
                        />
                        {errors.observationName && (
                          <span className="text-danger">
                            {errors.observationName.message}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3 pt-3">
                      <button
                        className="btn btn-success mx-2 mt-3"
                        type="button"
                        onClick={addItemToList}
                      >
                        Add to List
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr className="tableheaderrowview">
                        <th>Sr.No</th>
                        <th>Observation Name</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((items, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{items.observationName}</td>
                          <td className="text-center">
                            <button
                              className="btn"
                              type="button"
                              onClick={(e) => handleDelete(index, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="text-center">
                  <button className="btn btn-primary my-2" type="submit">
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
};

export default QualityCheckParameterForm;
